<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<main role="main">
    <h2>{{ 'footer.contact' | translate }}</h2>
    <section class="infoBox"></section>
    <section>
        <p>
            <a (click)="back()" class="k-button">back</a>
        </p>
    </section>
</main>